var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgGroupFilled = function SvgGroupFilled(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    d: "M3 18a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4H3ZM11.5 4.996c1.328 1.328 1.328 3.676 0 5.004-1.328 1.328-3.672 1.328-5 0-1.328-1.328-1.328-3.676 0-5.004 1.328-1.328 3.672-1.328 5 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#111827",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M16 4.5a2.5 2.5 0 1 1 0 5m1 3.5a4 4 0 0 1 4 4M3 18a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4H3Zm8.5-13.004c1.328 1.328 1.328 3.676 0 5.004-1.328 1.328-3.672 1.328-5 0-1.328-1.328-1.328-3.676 0-5.004 1.328-1.328 3.672-1.328 5 0Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGroupFilled);
export default ForwardRef;